// extracted by mini-css-extract-plugin
export var body = "_ma-8";
export var button = "_ma-0";
export var closeButton = "_ma-5";
export var content = "_ma-3";
export var empty = "_ma-f";
export var grid = "_ma-c";
export var header = "_ma-4";
export var icon = "_ma-1";
export var option = "_ma-d";
export var optionSelected = "_ma-e";
export var overlay = "_ma-2";
export var searchIcon = "_ma-a";
export var searchInput = "_ma-b";
export var searchWrapper = "_ma-9";
export var title = "_ma-6";
export var visuallyHidden = "_ma-7";